<template>
  <div>
    <!--    更新网点-->
    <el-button
      v-permit:remove="'but:compensationManagement:compensationList:batch:updataSite'"
      size="small" type="primary"
      @click="oneClickDel"
    >
      {{ $t('compensationManagement.updateBranch') }}
    </el-button>

    <el-dialog
      :title="$t('basicData.tips')"
      :visible.sync="dialogVisible"
      width="600px"
      @close="dialogVisible = false"
    >
      <el-form ref="ruleForm" size="small" :model="ruleForm">
        <el-form-item :label="$t('collectionCenter.AnjunTrackingNumber')" prop="orderNumbers">
          <el-input
            v-model="ruleForm.orderNumbers"
            :autosize="{ minRows: 3, maxRows: 6}"
            type="textarea"
            clearable
            :placeholder="$t('collectionCenter.BatchQuery') + '，' + $t('compensationManagement.Maximum500Orders')"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('GlobalSetObj.cancel') }}</el-button>
        <el-button type="primary" @click="submitBtn">{{ $t('GlobalSetObj.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { apiUpdataSite } from '@/api/compensationManagement/list';

export default {
  data() {
    return {
      dialogVisible: false,
      ruleForm: {
        orderNumbers: ''
      }
    };
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.clearForm();
      }
    }
  },
  methods: {
    // 一键剔除
    oneClickDel() {
      this.dialogVisible = true;
    },
    /**
     * 确定按钮
     */
    submitBtn() {
      this.$refs.ruleForm.validate(valid => {
        const params = cloneDeep(this.ruleForm);
        if (!valid) {
          return false;
        }
        params.orderNumbers = this.sanitizeClaimsNumberList(params.orderNumbers);
        if (params.orderNumbers.length > 500) {
          this.$message({
            type: 'warning',
            message: this.$t('compensationManagement.Maximum500Orders')
          });
          return false;
        }
        apiUpdataSite(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: this.$t('GlobalSetObj.TheOperationSucceeded')
            });
            this.dialogVisible = false;
          }
        });
      });
    },
    /**
     * 清空表单
     */
    clearForm() {
      this.$refs.ruleForm.resetFields();
    },
    sanitizeClaimsNumberList(list) {
      return (list.split('\n')).filter(item => item && item.trim()).map(items => items.replace(/\s/g, '').trim());
    }
  }
};
</script>

